import { BaseError } from './base';

export class CannotTrackError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'cannot_track_error',
      docsUrl: null,
      name: 'CannotTrackError',
      shortMessage: 'All track calls must be performed in the same node tick',
    });
  }
}
